// Platform detection utilities
export const getCurrentPlatform = () => {
  const hostname = window.location.hostname;
  
  if (hostname === 'TKT1.ai') {
    return 'TKT1-landing';
  } else {
    return 'TKT1-app';
  }
};

export const isTKT1Landing = () => {
  return getCurrentPlatform() === 'TKT1-landing';
};

export const isTKT1App = () => {
  return getCurrentPlatform() === 'TKT1-app';
};

export const getPlatformDisplayName = () => {
  const platform = getCurrentPlatform();
  switch (platform) {
    case 'TKT1-landing':
    case 'TKT1-app':
    default:
      return 'TKT1';
  }
};

export const getPlatformColors = () => {
  const platform = getCurrentPlatform();
  switch (platform) {
    case 'TKT1-landing':
    case 'TKT1-app':
    default:
      return {
        primary: '#6366f1', // Indigo color for TKT1
        secondary: '#8b5cf6',
        gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      };
  }
};

// API URL utilities
export const getApiUrl = () => {
  return process.env.REACT_APP_API_URL;
};

export const getSocketUrl = () => {
  return process.env.REACT_APP_SOCKET_URL;
};

export const getApiDataUrl = () => {
  return process.env.REACT_APP_API_DATA_URL;
}; 